import { render, staticRenderFns } from "./ProgramChallengesTable.vue?vue&type=template&id=c02625b6&scoped=true&lang=pug&"
import script from "./ProgramChallengesTable.vue?vue&type=script&lang=js&"
export * from "./ProgramChallengesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02625b6",
  null
  
)

export default component.exports